import { useInfiniteQuery } from "@tanstack/react-query";
import { useRestClient } from "../../api/RestClientContext";
import { PaymentStatus } from "../../models/payment";

const PAGE_SIZE = 20;

export const useGetPayHistory = () => {
    const client = useRestClient();

    const statuses: PaymentStatus[] = ['PENDING', 'EXT_ERR', 'INT_ERR', 'SUCCESS'];

    const query = useInfiniteQuery({
        queryKey: ['payHistory', statuses],
        queryFn: ({ pageParam = 0 }) => client.getPayHistory(pageParam, PAGE_SIZE, statuses),
        getNextPageParam: (lastPage, allPages) => {
            // Если последняя страница содержит меньше элементов чем PAGE_SIZE, значит больше страниц нет
            return lastPage.length === PAGE_SIZE ? allPages.length : undefined;
        },
        initialPageParam: 0,
        retry: false,
    });

    // Объединяем все страницы в один массив
    const payHistory = query.data?.pages.flat() || [];
    const hasMore = query.hasNextPage;

    return {
        payHistory,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isFetchingNextPage: query.isFetchingNextPage,
        error: query.error,
        loadNextPage: query.fetchNextPage,
        hasMore,
        refetch: query.refetch,
    };
};